'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'sun';
var width = 512;
var height = 512;
var aliases = [9728];
var unicode = 'f185';
var svgPathData = ['M16 156.6l65.4 94.9c1.9 2.7 1.9 6.3 0 9.1L16 355.4l113.3 20.8c3.3 .6 5.8 3.2 6.4 6.4L156.6 496l94.9-65.4c2.7-1.9 6.3-1.9 9.1 0L355.4 496l20.8-113.3c.6-3.3 3.2-5.8 6.4-6.4L496 355.4l-65.4-94.9c-1.9-2.7-1.9-6.3 0-9.1L496 156.6 382.7 135.8c-3.3-.6-5.8-3.2-6.4-6.4L355.4 16 260.5 81.4c-2.7 1.9-6.3 1.9-9.1 0L156.6 16 135.8 129.3c-.6 3.3-3.2 5.8-6.4 6.4L16 156.6zM368 256a112 112 0 1 1 -224 0 112 112 0 1 1 224 0z', 'M165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9l3.1-7.4-3.1 7.4c5 2.1 10.7 1.5 15.2-1.6L256 446.9l90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9L391 391l107.9-19.8c5.3-1 9.8-4.6 11.9-9.6s1.5-10.7-1.6-15.2L446.9 256l62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2l-7.4 3.1 7.4-3.1c-2.1-5-6.6-8.6-11.9-9.6L391 121 371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8zm94.9 78.6L355.4 16l20.8 113.3c.6 3.3 3.2 5.8 6.4 6.4L496 156.6l-65.4 94.9c-1.9 2.7-1.9 6.3 0 9.1L496 355.4 382.7 376.2c-3.3 .6-5.8 3.2-6.4 6.4L355.4 496l-94.9-65.4c-2.7-1.9-6.3-1.9-9.1 0L156.6 496 135.8 382.7c-.6-3.3-3.2-5.8-6.4-6.4L16 355.4l65.4-94.9c1.9-2.7 1.9-6.3 0-9.1L16 156.6l113.3-20.8c3.3-.6 5.8-3.2 6.4-6.4L156.6 16l94.9 65.4c2.7 1.9 6.3 1.9 9.1 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSun = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;